<template>
  <div>
    <Toolbar />
    <h3 style="margin: 10px">Ingresa tu firma en el recuadro de abajo:</h3>
    <div ref="signaturePad" class="signature-pad">
      <canvas
        ref="canvas"
        :width="canvasWidth"
        :height="canvasHeight"
        class="signature-pad-canvas"
        @touchstart="startDrawing"
        @touchmove="draw"
        @touchend="stopDrawing"
      ></canvas>
      <div>
        <v-btn
          :disabled="cargandoCreacionSolicitud"
          color="primary"
          @click="clearCanvas"
          >Limpiar</v-btn
        >
        <v-btn
          color="primary"
          @click="getSignatureImage"
          :disabled="cargandoCreacionSolicitud || !isAlreadyDrawing"
          :loading="cargandoCreacionSolicitud"
        >
          Firmar y Continuar
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { mapActions, mapGetters } from 'vuex'
import CreditoService from '@/servicios/credito'
import PersonaService from '@/servicios/persona'
import { ALERTA_ERROR } from '@/utilidades/utilidades'
import { GuardaFirmaAutografaDigitalMixin } from '@/mixins/persona/GuardaFirmaAutografaDigital.mixin'

export default {
  components: {
    Toolbar,
  },
  mixins: [GuardaFirmaAutografaDigitalMixin],
  data() {
    return {
      canvasWidth: 0,
      canvasHeight: 0,
      isDrawing: false,
      cargandoCreacionSolicitud: false,
      isAlreadyDrawing: false,
      lastX: 0,
      lastY: 0,
      scaleFactor: 2, // Escala para mejorar la resolución en dispositivos con alta densidad de píxeles
    }
  },
  mounted() {
    this.isAlreadyDrawing = false
    this.resizeCanvas()
    window.addEventListener('resize', this.resizeCanvas)
  },
  computed: {
    ...mapGetters({
      obtenerOtpFirma: 'credito/obtenerOtpFirma',
      obtenerEsOtpFirmaValido: 'credito/obtenerEsOtpFirmaValido',
      obtenerAceptaFirmar: 'credito/obtenerAceptaFirmar',
      obtenerSonTerminosBuroConfirmados:
        'credito/obtenerSonTerminosBuroConfirmados',
      obtenerCredito: 'credito/obtenerCredito',
    }),
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas)
  },
  methods: {
    resizeCanvas() {
      const signaturePad = this.$refs.signaturePad
      this.canvasWidth = signaturePad.clientWidth * this.scaleFactor
      this.canvasHeight = signaturePad.clientHeight * this.scaleFactor

      const canvas = this.$refs.canvas
      canvas.width = this.canvasWidth
      canvas.height = this.canvasHeight

      const ctx = canvas.getContext('2d')
      ctx.scale(this.scaleFactor, this.scaleFactor) // Escalar el contexto para mejorar la resolución
      ctx.strokeStyle = '#000'
      ctx.lineWidth = 2
    },
    startDrawing(e) {
      e.preventDefault()
      this.isAlreadyDrawing = true
      const rect = e.target.getBoundingClientRect()
      this.isDrawing = true
      this.lastX = (e.touches[0].clientX - rect.left) * this.scaleFactor
      this.lastY = (e.touches[0].clientY - rect.top) * this.scaleFactor
    },
    draw(e) {
      e.preventDefault()
      if (!this.isDrawing) return

      const rect = e.target.getBoundingClientRect()
      const currentX = (e.touches[0].clientX - rect.left) * this.scaleFactor
      const currentY = (e.touches[0].clientY - rect.top) * this.scaleFactor

      const ctx = this.$refs.canvas.getContext('2d')
      ctx.beginPath()
      ctx.moveTo(this.lastX, this.lastY)
      ctx.lineTo(currentX, currentY)
      ctx.stroke()

      this.lastX = currentX
      this.lastY = currentY
    },
    stopDrawing() {
      this.isDrawing = false
    },
    clearCanvas() {
      this.isAlreadyDrawing = false
      const ctx = this.$refs.canvas.getContext('2d')
      ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
    },
    // getSignatureImage() {
    //   const canvas = this.$refs.canvas;
    //   const ctx = canvas.getContext('2d');
    //   return canvas.toDataURL();
    // },
    getSignatureImage() {
      const canvas = this.$refs.canvas
      const imageDataURL = canvas.toDataURL('image/png')
      let valor = imageDataURL.split(',')
      let folioDigital = localStorage.getItem('FOLIO_DIGITAL')
      folioDigital = folioDigital.replace(/['"]+/g, '')

      const request = {
        folioDigital: folioDigital.toString(),
        base64Firma: valor[1],
      }

      this.cargandoCreacionSolicitud = true
      this.GuardaFirmaAutografaDigital(request)
      this.crearSolicitud().then(() => {
        this.cargandoCreacionSolicitud = false
        this.$router.push('/terminacion')
      })

      // setTimeout(() => {
      //   console.log('10 Segundos esperado', valor)
      //   this.cargandoCreacionSolicitud = false
      //   //this.$router.push('/terminacion')
      // }, 10000)
    },
    async crearSolicitud() {
      let result
      const crearSolicitudRequest =
        this.$store.getters['credito/obtenerSolicitudDigitalRequest']
      try {
        if (this.$store.getters['credito/obtenerAplicaDevolucionMonto']) {
          result = await CreditoService.actualizaMontoSolicitudDigital(
            crearSolicitudRequest
          )
        } else {
          result = await CreditoService.insertarSolicitudDigital(
            crearSolicitudRequest
          )

          console.log(JSON.stringify(crearSolicitudRequest))
        }
        if (result.data.Codigo == 200 && result.data.Estado == true) {
          let resultadoActualizacionPersona
          this.$store.dispatch(
            'personaDocumentos/insertarComprobante',
            result.data.Modelo.Comprobante
          )

          const persona = this.$store.getters['persona/obtenerPersona']
          if (persona.tipoPersona == 2) {
            resultadoActualizacionPersona =
              await PersonaService.actualizarDomicilioProspecto(persona)
            if (
              resultadoActualizacionPersona.data.Codigo == 200 &&
              resultadoActualizacionPersona.data.Estado == true
            ) {
              this.$store.dispatch('credito/actualizarConfirmacion', false)
              this.$store.dispatch('credito/actualizarFinalizado', true)

              console.log('Llega aqui al final de todo')
              this.cargandoCreacionSolicitud = false
              this.$router.push('terminacion')
            } else {
              this.enviarAlertaError({
                mensaje:
                  'Ha ocurrido un error al procesar tu solicitud. Por favor, intente acceder de nuevo al link que recibió vía Whatsapp y reinicie el proceso.',
                tiempo: ALERTA_ERROR.tiempo,
                visibilidad: ALERTA_ERROR.visible,
              })
              this.cargandoCreacionSolicitud = false
            }
          } else {
            this.$store.dispatch('credito/actualizarConfirmacion', false)
            this.$store.dispatch('credito/actualizarFinalizado', true)
            this.$router.push('terminacion')
            this.cargandoCreacionSolicitud = false
          }
        } else {
          console.error(result.data.Modelo.Mensaje)
          // this.enviarAlertaError({
          //   mensaje: result.data.Modelo.Mensaje || result.data.Mensaje,
          //   tiempo: ALERTA_ERROR.tiempo,
          //   visibilidad: ALERTA_ERROR.visible,
          // })
          this.cargandoCreacionSolicitud = false
        }
      } catch (error) {
        console.error(error)
        // this.enviarAlertaError({
        //   mensaje: ALERTA_ERROR.mensaje,
        //   tiempo: ALERTA_ERROR.tiempo,
        //   visibilidad: ALERTA_ERROR.visible,
        // })
        this.cargandoCreacionSolicitud = false
      }
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
      enviarAlertaExito: 'alerta/enviarAlertaExito',
      actualizaOTP: 'credito/actualizaOtpFirma',
      setEsOtpFirmaValido: 'credito/setEsOtpFirmaValido',
      setAceptaFirmar: 'credito/setAceptaFirmar',
      setSonTerminosBuroConfirmados: 'credito/setSonTerminosBuroConfirmados',
    }),
  },
}
</script>

<style scoped>
.signature-pad {
  position: relative;
  width: 90%;
  max-width: 100%; /* Ajusta el máximo ancho según tu diseño */
  margin: 0 auto;
}

.signature-pad-canvas {
  width: 94%;
  height: auto;
  border: 1px solid #000;
  touch-action: none; /* Evita el desplazamiento en dispositivos móviles al dibujar */
  margin: 10px;
}
canvas {
  border: 1px solid #000;
  max-width: 100%; /* Ajuste máximo del canvas al tamaño del contenedor */
  width: 100%;
  height: 450px !important;
}
button {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: green;
  color: #fff;
  border: none;
  cursor: pointer;
  margin: 10px;
}
button:hover {
  background-color: #0056b3;
}
</style>
